/**
 * Snowcubes Gift Card Catalog
 *
 * Source of truth for available card designs, font options, and related constants.
 * Loaded before gift-box-customizer-modal.js so the modal can read from
 * window.SnowcubesGiftCatalog.
 *
 * To add a new card design:
 *   1. Add entry to CARD_CATALOG below
 *   2. Upload artwork to Shopify Files or add a theme asset and reference it
 *      with themeAssetUrl(...)
 *   3. Add CSS rules for `.gift-modal__card-front.is-{cardId}` in gift-box-customizer-modal.css
 *   4. Add Figma template mapping in ai/skills/brand-snowcubes/references/figma-template-mapping.md
 */
(function initGiftCardCatalog(global) {
  'use strict';

  var GEFEN = { name: 'Gefen Benda', url: 'https://www.gefenbd.com' };

  function getCatalogScriptUrl() {
    try {
      var doc = global.document;
      if (!doc) return '';
      var currentScript = doc.currentScript;
      if (currentScript && currentScript.src) return currentScript.src;
      var scripts = doc.scripts || [];
      for (var index = scripts.length - 1; index >= 0; index -= 1) {
        var script = scripts[index];
        if (script && script.src && script.src.indexOf('gift-card-catalog.js') !== -1) {
          return script.src;
        }
      }
    } catch (_) {
      return '';
    }
    return '';
  }

  function themeAssetUrl(filename) {
    var assetUrls = global.SnowcubesGiftAssetUrls || {};
    if (assetUrls[filename]) return assetUrls[filename];

    var scriptUrl = getCatalogScriptUrl();
    if (scriptUrl) {
      try {
        return new URL(filename, scriptUrl).href;
      } catch (_) {
        // Fall through to a CDN-shaped URL so tests and non-browser callers get a URL.
      }
    }
    return 'https://cdn.shopify.com/s/files/1/0580/0647/0774/files/' + filename;
  }

  var CARD_CATALOG = [
    {
      id: 'birthday_2025_1',
      label: 'Birthday',
      imageAlt: 'Birthday-themed illustrated gift note',
      imageUrl: 'https://cdn.shopify.com/s/files/1/0580/0647/0774/files/birthday.png?v=1770571963',
      imageStyle: { maxHeight: '45%' },
      artist: GEFEN,
      greetingPresets: ['Happy birthday'],
      closingPresets: ['With love'],
    },
    {
      id: 'knicks_2026_the_leap',
      label: 'Knicks',
      imageAlt: 'Basketball-themed illustrated gift note',
      imageUrl: themeAssetUrl('gift-note-knicks-the-leap.svg'),
      imageStyle: { maxHeight: '58%', marginTop: '-0.25rem' },
      greetingPresets: ['FOR THE WIN'],
      closingPresets: ['Big Knicks Energy'],
    },
    {
      id: 'valentines_2025_1',
      label: "Valentine's",
      imageAlt: 'Valentine-themed illustrated gift note',
      imageUrl: 'https://cdn.shopify.com/s/files/1/0580/0647/0774/files/valentine.png?v=1770571963',
      imageStyle: { maxHeight: '45%' },
      artist: GEFEN,
      greetingPresets: ["Happy Valentine's"],
      closingPresets: ['With love'],
      hidden: true,
    },
    {
      id: 'valentines_2025_xl',
      label: "Valentine's XL",
      imageAlt: 'Large Valentine-themed illustrated gift note',
      imageUrl: 'https://cdn.shopify.com/s/files/1/0580/0647/0774/files/valentine_xl.png?v=1770571963',
      imageStyle: { maxHeight: '50%' },
      artist: GEFEN,
      greetingPresets: ["Happy Valentine's"],
      closingPresets: ['With love'],
      hidden: true,
    },
    {
      id: 'wedding_2025_1',
      label: 'Wedding',
      imageAlt: 'Wedding-themed illustrated gift note',
      imageUrl: 'https://cdn.shopify.com/s/files/1/0580/0647/0774/files/wedding.png?v=1770571963',
      imageStyle: { maxHeight: '45%' },
      artist: GEFEN,
      greetingPresets: ['Congratulations'],
      closingPresets: ['With love'],
    },
    {
      id: 'warm_winter_2025_1',
      label: 'Warm Winter',
      imageAlt: 'Winter-themed illustrated gift note',
      imageUrl: 'https://cdn.shopify.com/s/files/1/0580/0647/0774/files/warm_winter.png',
      imageStyle: { maxHeight: '36%' },
      artist: GEFEN,
      greetingPresets: ['Stay warm'],
      closingPresets: ['Feel better'],
    },
    {
      id: 'flavor_classic_v1',
      family: 'flavor',
      label: 'Cranberry Pistachio',
      imageAlt: 'Cranberry Pistachio gift note by Gefen Benda',
      imageUrl: themeAssetUrl('gift-note-cranberry-pistachio.png'),
      sourceFile: 'flavor_cranberry-pistachio.png',
      sha256: '4c486eec8f18fc52979c2a4e71b7a386244c64736f0851e916c0592e43595ed4',
      imageStyle: { maxHeight: '50%' },
      artist: GEFEN,
      greetingPresets: ['A little something for you'],
      closingPresets: ['Love'],
    },
    {
      id: 'flavor_strawberry_matcha_v1',
      family: 'flavor',
      label: 'Strawberry Matcha',
      imageAlt: 'Strawberry Matcha gift note by Gefen Benda',
      imageUrl: themeAssetUrl('gift-note-strawberry-matcha.png'),
      sourceFile: 'flavor_strawberry-matcha.png',
      sha256: 'b0b5a821394f2d65009d272d6957e7461a21e19816ad20c63563d4bac98efdfc',
      imageStyle: { maxHeight: '50%' },
      artist: GEFEN,
      greetingPresets: ['A little something for you'],
      closingPresets: ['Love'],
    },
    {
      id: 'flavor_cherry_oreo_v1',
      family: 'flavor',
      label: 'Cherry Oreo',
      imageAlt: 'Cherry Oreo gift note by Gefen Benda',
      imageUrl: themeAssetUrl('gift-note-cherry-oreo.png'),
      sourceFile: 'flavor_cherry-oreo.png',
      sha256: 'cdfffbc29c2197d2b9fddb502bcff4baa3f1a067686b721eb8bcd1de49ca6fe7',
      imageStyle: { maxHeight: '50%' },
      artist: GEFEN,
      greetingPresets: ['A little something for you'],
      closingPresets: ['Love'],
    },
    {
      id: 'flavor_pineapple_coconut_v1',
      family: 'flavor',
      label: 'Pineapple Coconut',
      imageAlt: 'Pineapple Coconut gift note by Gefen Benda',
      imageUrl: themeAssetUrl('gift-note-pineapple-coconut.png'),
      sourceFile: 'flavor_pineapple-coconut.png',
      sha256: '005a3f174f56bf019f87c38ead57f5f757cbe8d1bad7bcde98e14f678bf23e23',
      imageStyle: { maxHeight: '50%' },
      artist: GEFEN,
      greetingPresets: ['A little something for you'],
      closingPresets: ['Love'],
    },
    {
      id: 'flavor_oatmeal_v1',
      family: 'flavor',
      label: 'Oatmeal Raisin',
      imageAlt: 'Oatmeal Raisin Crumble gift note by Gefen Benda',
      imageUrl: themeAssetUrl('gift-note-oatmeal-raisin.png'),
      sourceFile: 'flavor_oat.png',
      sha256: '7b2edbae347c9c4e63441526d005a77827894d7fa5796fccb3d5d6a340135591',
      imageStyle: { maxHeight: '50%' },
      artist: GEFEN,
      greetingPresets: ['A little something for you'],
      closingPresets: ['Love'],
    }
  ];

  var CARD_CATALOG_BY_ID = CARD_CATALOG.reduce(function (acc, card) {
    acc[card.id] = card;
    return acc;
  }, {});

  var CARD_PICKER_CATALOG = CARD_CATALOG.filter(function (card) {
    return !card.hidden && card.family !== 'flavor';
  });

  var DEFAULT_CARD_ID = CARD_PICKER_CATALOG[0]
    ? CARD_PICKER_CATALOG[0].id
    : (CARD_CATALOG[0] ? CARD_CATALOG[0].id : 'knicks_2026_the_leap');

  // Consume the core handle map so the trigger and modal cannot drift.
  var FLAVOR_CARD_BY_HANDLE = (function deriveFlavorCardByHandle() {
    var matches = (global.SnowcubesGift && global.SnowcubesGift.FLAVOR_CARD_MATCHES) || {};
    var mapped = {};
    Object.keys(matches).forEach(function (handle) {
      if (matches[handle] && matches[handle].id) mapped[handle] = matches[handle].id;
    });
    return mapped;
  })();

  var MESSAGE_STARTERS = [
    { id: 'just_because_v1', label: 'Just because', message: 'There is no occasion. I checked the calendar twice. This is just for you.' },
    { id: 'birthday_v1', label: 'Birthday', message: 'Happy birthday. May the cake be good, the company better and the crunch loud. Share the box, or don\u2019t.' },
    { id: 'thank_you_v1', label: 'Thank you', message: 'Thank you. A card felt too small, so I sent a whole box.' },
    { id: 'new_baby_v1', label: 'New baby', message: 'Congratulations on the new arrival. Sleep when you can. Crunch when you can\u2019t.' },
    { id: 'get_well_v1', label: 'Get well', message: 'Rest up. This box reported for keep-you-company duty.' },
    { id: 'housewarming_v1', label: 'Housewarming', message: 'Congratulations on the new place. This box would like to be your first houseguest.' },
  ];

  function cardIdForProductHandle(productHandle) {
    if (global.SnowcubesGift && typeof global.SnowcubesGift.flavorCardMatchForHandle === 'function') {
      var match = global.SnowcubesGift.flavorCardMatchForHandle(productHandle);
      if (match && match.id) return match.id;
      return DEFAULT_CARD_ID;
    }
    if (typeof productHandle !== 'string') return DEFAULT_CARD_ID;
    var handle = productHandle.trim().toLowerCase();
    return FLAVOR_CARD_BY_HANDLE[handle] || DEFAULT_CARD_ID;
  }

  function starterById(starterId) {
    if (typeof starterId !== 'string') return MESSAGE_STARTERS[0];
    var found = MESSAGE_STARTERS.filter(function (item) { return item.id === starterId; })[0];
    return found || MESSAGE_STARTERS[0];
  }

  // Occasion chips replace the note only while it is empty or still the last starter.
  function applyStarterIfSafe(currentMessage, lastStarterId, nextStarterId) {
    var next = starterById(nextStarterId);
    var last = lastStarterId ? starterById(lastStarterId) : null;
    var current = typeof currentMessage === 'string' ? currentMessage : '';
    var untouched = current.trim() === '' || (last && current === last.message);
    return {
      applied: untouched,
      message: untouched ? next.message : current,
      starterId: untouched ? next.id : lastStarterId || null,
    };
  }

  var FONT_OPTIONS = [
    { id: 'serif', label: 'Serif', previewClass: 'is-serif' },
    { id: 'modern', label: 'Modern', previewClass: 'is-modern' },
  ];

  var DEFAULT_FONT_ID = FONT_OPTIONS[0] ? FONT_OPTIONS[0].id : 'serif';

  var GREETING_MAX_LENGTH = 30;
  var CLOSING_MAX_LENGTH = 20;

  /**
   * Normalize a font ID from user input or stored config.
   * Handles legacy aliases (script, elegant, classic) and unknown values.
   * @param {*} fontId
   * @returns {string}
   */
  function normalizeFontId(fontId) {
    if (typeof fontId !== 'string') return DEFAULT_FONT_ID;
    var normalized = fontId.trim().toLowerCase();
    if (normalized === 'script' || normalized === 'elegant') return 'serif';
    if (normalized === 'classic') return 'serif';
    var isKnown = FONT_OPTIONS.some(function (font) { return font.id === normalized; });
    return isKnown ? normalized : DEFAULT_FONT_ID;
  }

  // Public API
  var api = {
    CARD_CATALOG: CARD_CATALOG,
    CARD_CATALOG_BY_ID: CARD_CATALOG_BY_ID,
    CARD_PICKER_CATALOG: CARD_PICKER_CATALOG,
    DEFAULT_CARD_ID: DEFAULT_CARD_ID,
    FLAVOR_CARD_BY_HANDLE: FLAVOR_CARD_BY_HANDLE,
    MESSAGE_STARTERS: MESSAGE_STARTERS,
    cardIdForProductHandle: cardIdForProductHandle,
    starterById: starterById,
    applyStarterIfSafe: applyStarterIfSafe,
    FONT_OPTIONS: FONT_OPTIONS,
    DEFAULT_FONT_ID: DEFAULT_FONT_ID,
    GREETING_MAX_LENGTH: GREETING_MAX_LENGTH,
    CLOSING_MAX_LENGTH: CLOSING_MAX_LENGTH,
    normalizeFontId: normalizeFontId,
  };

  global.SnowcubesGiftCatalog = api;

  // Jest / Node usage
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }
})(typeof window !== 'undefined' ? window : globalThis);
